<template>
  <div class="opage">
    <!-- 检品详情 -->
    <div>
      <detailHeader></detailHeader>
      <div style="padding: 0 24px" v-if="purchase.inspect_sn">
        <div class="head">
          <div class="headOpt">
            <!-- 普检单   -->
            <span class="redFont"> {{ purchase.inspect_sn }} </span>
            <span style="color:#fa5058 ;font-size: 18px;font-weight: bold; margin-right: 20px;">
              ({{ purchase.typeName }})
            </span>
            <span v-if="purchase.user_attribute == '付费会员'" style="color: #fa5058;font-size: 18px;font-weight: bold;">
              ({{ purchase.user_attribute }})
            </span>
            <span v-else-if="purchase.user_attribute == 'SVIP'" style="color: rgb(247, 226, 3);font-size: 25px;
                  font-weight: bold;">
              ({{ purchase.user_attribute }})
            </span>
            <span v-else-if="purchase.user_attribute != ''">({{ purchase.user_attribute }})</span>
          </div>
          <div class="headOpt">
            <!-- 配货   -->
            {{ $t("message.distribution") }}：
            <span> {{ purchase.p_admin.realname }} </span>
          </div>
          <div class="headOpt">
            <!-- 普/精检员   -->
            {{ $t("message.generalQualityInspector") }}：
            <span>
              {{ purchase.j_admin ? purchase.j_admin.realname : "未分配" }}</span>
          </div>
          <div class="headOpt">
            <!-- 布标处理   -->
            {{ $t("message.clothLabelTreatment") }}：
            <span>
              {{ purchase.label_admin ? purchase.label_admin.realname : "未分配" }}
            </span>
          </div>
          <div class="headOpt">
            <!-- 状态   -->
            {{ $t("message.status") }}：
            <span> {{ purchase.statusName }} </span>
          </div>
        </div>
        <div class="tableBody">
          <div class="mytable">
            <div class="tul ttt">
              <!-- 选中 -->
              <div class="tli ttt">{{ $t("message.select") }}</div>
              <!-- 番号 -->
              <div class="tli ttt">{{ $t('message.mash') }}</div>
              <!-- 照片 -->
              <div class="tli ttt">{{ $t("message.pic") }}</div>
              <!-- 业务编辑商品属性 -->
              <div class="tli ttt theBusinessEditsTheCommodityProperties listTd">
                {{ $t("message.theBusinessEditsTheCommodityProperties") }}
              </div>
              <!-- 附加服务 -->
              <div class="tli ttt listTd additionalService">
                {{ $t("message.additionalServices") }}
              </div>
              <!-- 担当备注 -->
              <div class="tli ttt remarkTd businessRemark">
                {{ $t("message.responsibleForRemarks") }}
              </div>
              <!-- 采购备注 -->
              <div class="tli ttt remarkTd">
                {{ $t("message.purchasingNotes") }}
              </div>
              <!-- 核查员备注 注:核查员就是配货 -->
              <div class="tli ttt remarkTd">
                {{ $t("message.verifierSNotes") }}
              </div>
              <!-- 数量 -->
              <div class="tli ttt quantityTd">
                {{ $t("message.quantity") }}
              </div>
              <!-- 单价(元) -->
              <div class="tli ttt">{{ $t("message.priceYuan") }}</div>
              <!-- 物流号 -->
              <div class="tli ttt listTd logisticsNumber">
                {{ $t("message.logisticsNumber") }}
              </div>
              <!-- 状态 -->
              <div class="tli ttt">{{ $t("message.status") }}</div>
            </div>
            <div class="tcon" v-for="(orderItem, orderIndex) in tableData" :key="'order' + orderIndex">
              <div class="tul tconHead">
                <div class="tconHeadOpt flexDirColumn">
                  <div>
                    <!-- 客户付款时间 -->
                    <p>{{ $t("message.customerPaymentTime") }}：</p>
                    <p>{{ orderItem.order_time_node.datetime_pay_confirm }}</p>
                  </div>
                </div>
                <div class="tconHeadOpt flexDirColumn">
                  <div>
                    <p>
                      <span class="yellowFont">{{ orderItem.order_sn }}</span>
                    </p>
                    <p>{{ orderItem.user.realname }}</p>
                  </div>
                </div>
                <div class="tconHeadOpt">
                  <!-- 交易号 -->
                  {{ $t("message.transactionNumber") }}
                  <span class="yellowFont">{{ orderItem.purchase_no }}</span>
                </div>
                <div class="tconHeadOpt">
                  <!-- 业务 -->
                  {{ $t("message.business") }}：
                  {{ orderItem.y_admin.realname }}
                </div>
                <div class="tconHeadOpt">
                  <!-- 采购 -->
                  {{ $t("message.purchase") }}：
                  {{ orderItem.g_admin.realname }}
                </div>
                <div class="tconHeadOpt">
                  <!-- 配货 -->
                  {{ $t("message.distribution") }}：
                  {{ orderItem.p_admin.realname }}
                </div>
              </div>
              <div class="tul tbo" v-for="(goodsItem, goodsIndex) in orderItem.inspect_detail"
                :key="'goods' + goodsIndex">
                <!-- 选中 -->
                <div class="tli tbo">
                  <el-checkbox v-model="goodsItem.checked" @change="changeItem"></el-checkbox>
                </div>
                <div class="tli tbo NO">{{ goodsItem.order_purchase.order_detail.sorting }}</div>
                <!-- 照片 -->
                <div class="tli tbo">
                  <div class="img">
                    <el-popover placement="right" width="300" trigger="hover">
                      <img :src="goodsItem.order_purchase.order_detail.pic" alt=""
                        style="width: 300px; height: 300px" />
                      <a :href="goodsItem.order_purchase.order_detail.link" target="_blank" slot="reference">
                        <img :src="goodsItem.order_purchase.order_detail.pic" alt=""
                          style="width: 60px; height: 60px" />
                      </a>
                    </el-popover>
                  </div>
                </div>
                <!-- 业务编辑商品属性 -->
                <div class="tli tbo theBusinessEditsTheCommodityProperties listTd">
                  <div>
                    <div slot="reference">
                      <p v-for="( goodsDetailItem, goodsDetailIndex) in goodsItem.order_purchase.order_detail.detail_y"
                        :key="'goodsDetail' + goodsDetailIndex">
                        {{ goodsDetailItem.key }}：
                        {{ goodsDetailItem.value }}
                      </p>
                    </div>
                  </div>
                </div>
                <!-- 附加服务 -->
                <div class="tli tbo listTd additionalService">
                  <div class="additionalServiceList">
                    <p class="additionalServiceItem"
                      v-for="(optionItem, optionIndex) in goodsItem.order_purchase.order_detail.option"
                      :key="'option' + optionIndex">
                      {{ optionIndex + 1 }}: {{ optionItem.name }} *
                      {{ optionItem.num }} * {{ optionItem.price }}
                    </p>
                  </div>
                </div>
                <!-- 担当备注 -->
                <div class="tli tbo remarkTd businessRemark">
                  <textarea disabled v-model="goodsItem.order_purchase.order_detail.y_remark"></textarea>
                </div>
                <!-- 采购备注 -->
                <div class="tli tbo remarkTd">
                  <textarea disabled v-model="goodsItem.order_purchase.order_detail.g_remark"></textarea>
                </div>
                <!-- 核查员备注 注:核查员就是配货 -->
                <div class="tli tbo remarkTd">
                  <textarea disabled v-model="goodsItem.order_purchase.order_detail.p_remark"></textarea>
                </div>
                <!-- 数量 -->
                <div class="tli tbo quantityTd">
                  <div class="quantityList">
                    <p>
                      <span>{{ $t("message.numberOfProductsToBeSubmittedForInspection") }}</span>
                      <strong>{{ goodsItem.num }}</strong>
                    </p>
                    <p>
                      <span>{{ $t("message.pendingPrecisionTestNumber") }}</span>
                      <strong>{{ goodsItem.inspect_num }}</strong>
                    </p>
                    <p>
                      <span>{{ $t("message.numberOfGeneralTestPrecisionTestProblems") }}</span>
                      <strong>{{ goodsItem.inspect_bad_num }}</strong>
                    </p>
                    <p>
                      <span>{{ $t("message.numberOfLabelsToBeLaid") }}</span>
                      <strong>{{ goodsItem.label_should_num }}</strong>
                    </p>
                    <p>
                      <span>{{ $t("message.numberOfLabelLayoutProblems") }}</span>
                      <strong>{{ goodsItem.label_bad_num }}</strong>
                    </p>
                  </div>
                </div>
                <!-- 单价(元) -->
                <div class="tli tbo">
                  {{ goodsItem.order_purchase.order_detail.confirm_price }}
                </div>
                <!-- 物流号 -->
                <div class="tli tbo listTd logisticsNumber">
                  <div>
                    <el-popover placement="bottom" trigger="hover">
                      <p v-for="express in goodsItem.order_purchase.order_purchase_express" :key="express.id">
                        {{ express.express_no }}
                      </p>
                      <div slot="reference">
                        <p v-for="express in goodsItem.order_purchase.order_purchase_express" :key="express.id">
                          {{ express.express_no }}
                        </p>
                      </div>
                    </el-popover>
                  </div>
                </div>
                <!-- 状态 -->
                <div class="tli tbo">
                  {{ goodsItem.statusName }}
                </div>
              </div>
            </div>
            <!-- 数据为空 -->
            <div class="tul tNullData" v-if="tableData.length == 0">
              {{ $t("message.dataIsNull") }}
            </div>
          </div>
        </div>
        <!-- 检品单备注 -->
        <div class="remarksOnInspectionListBox">
          <span class="remarksBoxTitle">
            {{ $t("message.remarksOnInspectionList") }}
          </span>
          <!-- 请输入备注 -->
          <el-input type="textarea" class="remarkBox" :placeholder="$t('message.pleaseEnterRemarks')" rows="5"
            v-model="purchase.remark" @blur="inspectUpdateRemark">
          </el-input>
        </div>
        <!-- 是否需要布标处理： -->
        <!-- 是否需要计算绩效 -->
        <div class=" radio" v-if="purchase.recheckName == '复检单'">
          {{ $t("message.whetherPerformanceNeedsToBeCalculated") }}:
          <span v-if="isAuth(500)">
            <el-radio v-model="purchase.is_need_performance" :label="1"
              @change="switchInspectNeedPerformance">是</el-radio>
            <el-radio v-model="purchase.is_need_performance" :label="0"
              @change="switchInspectNeedPerformance">否</el-radio>
          </span>
          <span v-else> {{ purchase.is_need_performance == 1 ? "是" : "否" }}</span>
          <!-- switchInspectNeedPerformance -->
        </div>
      </div>
    </div>
    <!-- 检品单调配 -->
    <selectTheInspector ref="selectTheInspector"></selectTheInspector>
    <!-- 分配布标 -->
    <adjustTheSpreader ref="adjustTheSpreader"></adjustTheSpreader>
    <!-- 提交检品单选择组织 -->
    <selectionOfOrganization ref="selectionOfOrganization"></selectionOfOrganization>
    <!-- 待普/精检数修改弹窗 -->
    <subjectToRevisionOfPrecisionCheckNumber ref="subjectToRevision"></subjectToRevisionOfPrecisionCheckNumber>
    <!-- 用户操作 -->
    <div class="userOperations">
      <div class="operationsLeft">
        <div class="check">
          <el-checkbox v-model="checked" @change="allChecked"></el-checkbox>
          <!-- 全选 -->
          <span> {{ $t("message.allChecked") }}</span>
        </div>
        <!-- 选中同包裹商品 -->
        <el-button type="primary" class="primary">
          {{ $t("message.selectTheSamePackage") }}
        </el-button>
        <!-- 复制选择商品信息 -->
        <el-button type="primary" class="primary" @click="copyText">
          {{ $t("message.copySelectedProductInformation") }}
        </el-button>
        <!-- 从检品单移除 -->
        <el-button type="primary" class="dark" @click="inspectRemoveDetail"
          v-if="isAuth(198) && purchase.statusName == '待分配检品'">
          {{ $t("message.removeFromInspectionList") }}
        </el-button>
        <!-- 检品单废弃 -->
        <el-button type="primary" class="primary" @click="inspectDiscard"
          v-if="isAuth(199) && purchase.statusName == '待分配检品'">
          {{ $t("message.inspectionListDiscarded") }}
        </el-button>
        <!-- 打印检品单唛头 -->
        <el-button type="primary" class="primary" @click="printTheShippingMarkOfTheInspectionList">
          {{ $t("message.printTheShippingMarkOfTheInspectionList") }}
        </el-button>
      </div>
      <div class="operationsRight">
        <!-- 调整布标员 -->
        <el-button type="success" @click="adjustTheSpreader" v-if="isAuth(480)">
          {{ $t("message.adjustTheSpreader") }}
        </el-button>
        <!-- 修改待普/精检数 -->
        <el-button type="primary" class="dark" @click="modifiedGeneralInspection('generalOrPrecisionExamination')"
          v-if="isAuth(200)">
          {{ $t("message.modifyThePendingPrecisionCheck") }}
        </el-button>
        <!-- 修改待布标处理数 -->
        <el-button type="primary" class="dark" @click="modifiedGeneralInspection('clothLabelTreatment')"
          v-if="isAuth(201)">
          {{ $t("message.exampleChangeTheNumberOfLabelsToBeBlanked") }}
        </el-button>
        <!-- 包裹拆分 -->
        <el-button type="primary" class="primary" @click="modifiedGeneralInspection('breakUp')" v-if="isAuth(202)">
          {{ $t("message.packageSplit") }}
        </el-button>
        <!-- 检品单调配 -->
        <el-button type="primary" class="primary" @click="inspectionListDeployment" v-if="isAuth(203)">
          {{ $t("message.inspectionListDeployment") }}
        </el-button>
        <!-- 提交检品 -->
        <el-button type="primary" @click="submitForInspection" v-if="isAuth(204)">
          {{ $t("message.submitForInspection") }}
        </el-button>
      </div>
    </div>
    <!-- 打印检品单唛头 -->
    <div v-show="true">
      <Inspection ref="Inspection" :datas="purchase" v-if="show" />
    </div>
  </div>
</template>
<script>
import uploadFile from "@/components/uploadFile/uploadFile.vue";
import detailHeader from "@/components/header/detailHeader";
import subjectToRevisionOfPrecisionCheckNumber from "./components/subjectToRevisionOfPrecisionCheckNumber.vue";
import selectTheInspector from "./components/selectTheInspector.vue";
import adjustTheSpreader from "./components/adjustTheSpreader.vue";
import selectionOfOrganization from "./components/selectionOfOrganization.vue";
import Inspection from "../../../components/Printedsheet/Inspection";
export default {
  metaInfo() {
    return {
      title: '检品单详情',
    };
  },
  data() {
    return {
      purchase: {}, //详情返回的所有数据
      tableData: [],
      checkedList: [], //选中的数据
      checked: true,
      show: false,//打印用
    };
  },
  components: {
    uploadFile,
    detailHeader,
    subjectToRevisionOfPrecisionCheckNumber,
    selectTheInspector,
    adjustTheSpreader,
    selectionOfOrganization,
    Inspection,
  },
  computed: {},
  created() {
    this.getData();
  },
  methods: {
    // 获取详情数据
    getData() {
      this.$api.inspectionApi
        .inspectDetail({
          inspect_sn: this.$route.query.id,
        })
        .then((res) => {
          if (res.data == false) {
            this.tableData = [];

            return false;
          }
          // 处理商品列表数据
          this.tableData = res.data.groupByPurchaseNo;
          this.processingData(this.tableData);

          this.purchase = res.data;
        });
    },
    // 处理详情数据
    processingData(data) {

      data.forEach((dataItem) => {
        // 添加收起与展开参数
        dataItem.checked = true;
        dataItem.inspect_detail.forEach((inspect_detailItem) => {
          inspect_detailItem.checked = true;
        });
      });
      this.allChecked()
    },
    // 单选
    changeItem() {
      this.checkedList = [];
      let allcheck = true;
      this.tableData.forEach((item) => {
        item.inspect_detail.forEach((inspect_detailItem) => {
          if (inspect_detailItem.checked) {
            this.checkedList.push(inspect_detailItem);
          } else {
            allcheck = false;
          }
        });
      });
      this.checked = allcheck;
      this.$forceUpdate();
    },
    //  全选
    allChecked() {
      this.checkedList = [];
      this.tableData.forEach((item) => {
        item.inspect_detail.forEach((inspect_detailItem) => {
          inspect_detailItem.checked = this.checked;
          if (inspect_detailItem.checked) {
            this.checkedList.push(inspect_detailItem);
          }
        });
      });

      this.$forceUpdate();
    },
    // 复制付款后订单详情链接和番号
    copyText() {
      const selectedList = []
      this.tableData.forEach((orderItem) => {
        orderItem.inspect_detail.forEach((goodsItem) => {
          if (goodsItem.checked) {
            selectedList.push({
              order_sn: orderItem.order_sn,
              sorting: goodsItem.order_purchase.order_detail.sorting
            })
          }
        })
      })
      if (selectedList.length === 0) {
        return this.$message.error(this.$t("message.pleaseSelectAtLeastOne"))
      }
      selectedList.sort((a, b) => Number(a.sorting) - Number(b.sorting))
      const currentUrl = window.location.href.split('#')[0]
      const copyContent = selectedList.map(item => {
        const routeUrl = this.$router.resolve({
          name: 'orderPaymentDetail',
          query: { order_sn: item.order_sn }
        }).href
        return `${currentUrl}${routeUrl}\n${item.sorting}番`
      }).join('\n')
      this.copy(copyContent)
    },
    // 获取选中商品的id
    getChioseId() {
      let ids = [];
      this.checkedList.forEach((checkedItem) => {
        ids.push(checkedItem.id);
      });
      return ids;
    },
    // 从检品单移除
    inspectRemoveDetail() {
      if (!this.checkedList.length) {
        // 未选择操作数据
        return this.$message.warning(
          this.$t("message.operationDataIsNotSelected")
        );
      }
      // 请先和检品确认是否已经开始检品，已经开始检品的请勿取消！
      this.$confirm(
        this.$t("message.pleaseFirstConfirmWithTheInspection"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.notarize"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.$api.inspectionApi
            .inspectRemoveDetail({
              inspectDetailIdSet: this.getChioseId(),
            })
            .then((res) => {
              //if(res.data.code !=0) return this.$message.error(res.data.message)
              // 接下来的操作
              this.$message.success(res.msg);
              this.getData();
            });
        })
        .catch(() => { });
    },
    //检品单废弃
    inspectDiscard() {
      // 是否废弃检品单
      this.$confirm(
        this.$t("message.whetherToDiscardTheInspectionList"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.notarize"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.$api.inspectionApi
            .inspectDiscard({ inspect_sn: this.$route.query.id })
            .then((res) => {
              this.$message.success(res.msg, "3秒后自动关闭");
              setTimeout(() => {
                window.open("about:blank", "_top").close();
              }, 3000);
            });
        })
        .catch(() => { });
    },
    //备注修改
    inspectUpdateRemark() {
      let datas = {
        inspect_sn: this.$route.query.id,
        remark: this.purchase.remark,
      };
      this.$api.inspectionApi.inspectUpdateRemark(datas);
    },
    // 修改待普/精检数或者修改布标处理数
    modifiedGeneralInspection(type) {

      if (this.checkedList.length) {
        this.$refs.subjectToRevision.open(type);
      } else {
        // 未选择操作数据
        this.$message.warning(this.$t("message.operationDataIsNotSelected"));
      }
    },
    //检品单调配
    inspectionListDeployment() {
      this.$refs.selectTheInspector.open();
    },
    // 提交检品
    submitForInspection() {
      if (this.purchase.j_admin) {
        // 是否确认提交检品单
        this.$confirm(this.$t("message.confirmToSubmitTheInspectionList"), {
          type: "warning",
        })
          .then(() => {
            this.$api.inspectionApi
              .inspectSubmitInspect({
                inspect_sn: this.purchase.inspect_sn,
              })
              .then((res) => {
                this.$message.success(res.msg);
                setTimeout(() => {
                  window.open("about:blank", "_top").close();
                }, 3000)
              });
          })
          .catch(() => {
            //this.$message({
            //type: 'info',
            //message: '已取消删除'
            //});
          });
      } else {
        this.$refs.selectionOfOrganization.open();
      }

    },
    //打印检品单唛头
    printTheShippingMarkOfTheInspectionList() {
      this.show = true
      this.$nextTick(() => {
        this.$print(this.$refs.Inspection);
        this.show = false
      });

    },
    //调整布标员
    adjustTheSpreader() {
      this.$refs.adjustTheSpreader.open();
    },
    // 检品-修改检品单是否需要计算绩效
    switchInspectNeedPerformance() {
      let datas = {
        inspect_sn: this.purchase.inspect_sn,
        is_need_performance: this.purchase.is_need_performance,
      }
      this.$api.inspectionApi.switchInspectNeedPerformance(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
  },
};
</script>
<style lang='scss' scoped='scoped'>
@import "@/css/mixin.scss";

* {
  box-sizing: border-box;
}

.opage {
  min-width: 1910px;
  min-height: 100vh;
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  .userOperations {
    height: 112px;
    background: #f8f8f8;
    position: sticky;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px;
    border: 1px solid #edeff4;
    border-radius: 8px;
    position: sticky;
    top: 10px;
    margin: 24px 24px 0;

    .operationsLeft {
      display: flex;
      align-items: center;

      .check {
        margin-right: 52px;

        span {
          margin-left: 8px;
        }
      }

      .el-button {
        margin-left: 0;
        margin-right: 16px;
      }
    }

    .operationsRight {
      display: flex;
      align-items: center;

      .el-button {
        margin-left: 0;
        margin-right: 16px;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}

.head {
  display: flex;
  align-items: center;
  margin-top: 24px;
  height: 40px;
  margin-top: 20px;
  margin-bottom: 16px;

  .headOpt {
    margin-right: 45px;
  }
}

.tableBody {
  margin-top: 24px;
  background: #f8f8f8;
  border-radius: 8px;
  padding: 25px;

  .mytable {
    .tul {
      display: flex;
      align-items: center;

      // 表头
      &.ttt {
        background: #edeff4;
        border-radius: 4px 4px 0px 0px;
      }

      //单条数据二级头部
      &.tconHead {
        height: 60px;
        background: #545467;
        border-radius: 4px;
        color: white;
        padding: 0 24px;

        .tconHeadOpt {
          margin-right: 40px;
          display: flex;
          justify-content: center;
          align-items: center;

          &:last-child {
            margin-right: 0;
          }
        }
      }

      //单条数据二级数据
      &.tbo {
        border-bottom: solid 1px #edeff4;

        &:hover {
          background-color: #eee;
        }
      }

      &.tfoot {
        min-height: 60px;
        display: flex;
        align-items: center;
        padding: 10px;

        .el-button {
          margin-right: 15px;
        }
      }

      // 单个单元格
      .tli {
        box-sizing: border-box;
        flex: 1;
        text-align: center;
        margin: 0 6px;

        &.ttt {

          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          line-height: 20px;
        }

        &.tbo {
          display: flex;
          justify-content: center;
          align-items: center;
          overflow: auto;
          padding-top: 10px;
          padding-bottom: 10px;
        }

        // 列表单元格信息
        &.listTd {
          flex: 0 0 150px;

          &.tbo {
            flex-direction: column;
            align-items: flex-start;

            >div {


              p {
                width: 100%;
                text-align: left;
              }
            }


            -webkit-box-orient: vertical;
            // height: unset;
            // flex-wrap: wrap;
            // height: 112px;
          }
        }

        // 备注单元格信息
        &.remarkTd {
          flex: 0 0 120px;
          padding: 5px 0;

          textarea {
            width: 100%;
            height: 100px;
            font-size: 17px !important;
            font-family: "Microsoft YaHei" !important
          }

          &.tbo {

            // 和其他页面统一所以不加
            // border: 1px solid #dcdfe6;
            border-radius: 4px;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            padding: 13px 9px;
          }
        }

        // 业务备注优先展示完整内容
        &.businessRemark {
          flex-basis: 240px;
        }

        // 附加服务加宽，单条服务保持一行
        &.additionalService {
          flex-basis: 260px;

          &.tbo {
            align-items: flex-start;
          }

          .additionalServiceList {
            width: 100%;
          }

          .additionalServiceItem {
            margin: 0 0 4px;
            color: #036eb8;
            white-space: nowrap;

            &:last-child {
              margin-bottom: 0;
            }
          }
        }

        // 五项检品数量集中在一个区域纵向展示
        &.quantityTd {
          flex: 0 0 250px;

          .quantityList {
            width: 100%;

            p {
              display: flex;
              justify-content: space-between;
              gap: 12px;
              margin-bottom: 5px;
              line-height: 20px;
              text-align: left;

              &:last-child {
                margin-bottom: 0;
              }
            }

            strong {
              min-width: 30px;
              color: #333;
              text-align: right;
            }
          }
        }


        // 业务编辑商品属性
        &.theBusinessEditsTheCommodityProperties {
          flex: 0 0 120px;
        }

        // 物流号
        &.logisticsNumber {
          justify-content: center !important;
        }
      }
    }

    //内容数据
    // .tcon {
    // }
    .tNullData {
      font-size: 25px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 10px;
      color: #bbbec7;
    }
  }
}

.remarksOnInspectionListBox {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  height: 168px;
  padding: 24px;
  background: #f8f8f8;
  border: 1px solid #edeff4;
  border-radius: 8px;
  margin-top: 24px;

  .remarksBoxTitle {
    flex: 0 0 126px;
  }
}

.redFont {
  color: #fa5058;
}

.yellowFont {
  color: #f9f871;
}

.el-checkbox {
  transform: scale(1.5);
}

.radio {
  margin-top: 20px;
  display: flex;
  line-height: 40px;
  font-size: 20px;


  span {
    margin-left: 20px;
    color: #fa5058;
  }

  /deep/.el-radio__input {
    transform: scale(1.5) !important;
    margin-left: 20px;
  }
}
</style>
